import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@kizen/kds/Icon';
import type { ToolItem } from 'ts-components/PiChat/PiChatLog';
import { CaptureToolRow } from 'ts-components/PiChat/capture/CaptureToolRow';
import { EventRow } from 'ts-components/PiChat/styles';
import { parsePushSummary } from './pushSummary';

const PushRow: FC<{ action: 'created' | 'updated' }> = ({ action }) => {
  const { t } = useTranslation();
  return (
    <EventRow $tone="success" data-qa-id="ai-block-panel-push-result">
      <Icon icon="custom-circle-check" size="sm" color="feedback-success" />
      {action === 'created' ? t('Block created') : t('Block updated')}
    </EventRow>
  );
};

export const BlockToolRow: FC<{
  item: ToolItem;
  wsUrl: string;
}> = ({ item, wsUrl }) => {
  const push = parsePushSummary(item);
  return (
    <>
      <CaptureToolRow item={item} wsUrl={wsUrl} />
      {push ? <PushRow action={push.action} /> : null}
    </>
  );
};
